import React from "react";
import "./Input.css";
const Input = ({ isTextArea, placeholder, name, type, onInput }) => {



  return (
    <div className="input_container">
      {isTextArea ? (
        <textarea
          className="main_textarea"
          placeholder={placeholder}
          name={name}
          onChange={onInput}
        />
      ) : (
        <input
          type={type}
          className="main_input"
          placeholder={placeholder}
          name={name}
          onChange={onInput}
        />
      )}
    </div>
  );
};

export default Input;
